export default "__VITE_ASSET__YS07eRye__"